import $i18n from '@/locale-view/i18n';
import CnAddressSelect from '@cainiaofe/cn-address';
import locale from '@cainiaofe/cn-address/lib/locale';
import { isEmptyButNotZero } from '@/common/util/util';
import { DisplayPosition } from '@/common/manager/position//display-position';
import isPlainObject from 'lodash/isPlainObject';
import set from 'lodash/set';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'AddressSelect',
    component: CnAddressSelect,
    formComponent: CnAddressSelect,
    filterItemBeforeHandler: (filterItemProps, config) => {
        const { componentProps } = config || {};
        if (isPlainObject(componentProps)) {
            const { extra } = componentProps;
            const { realm, needSkipLevelData, showDisabledDivision } = extra || {};
            if (realm) {
                set(componentProps, 'config.realm', realm);
            }
            if (needSkipLevelData) {
                set(componentProps, 'needSkipLevelData', needSkipLevelData);
            }
            if (showDisabledDivision) {
                set(componentProps, 'showDisabledDivision', showDisabledDivision);
            }
            delete componentProps.extra;
        }
    },
    formItemBeforeHandler: (formItem) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (isPlainObject(componentProps)) {
                const { extra = {} } = componentProps;
                if (isPlainObject(extra)) {
                    for (const key in extra) {
                        const temV = extra[key];
                        if (key && !isEmptyButNotZero(temV)) {
                            if (key === 'needSkipLevelData' ||
                                key === 'showDisabledDivision' ||
                                key === 'isSearchById') {
                                set(componentProps, `${key}`, temV);
                            }
                            else {
                                set(componentProps, `config.${key}`, temV);
                            }
                        }
                    }
                }
                delete componentProps.extra;
            }
        }
    },
};
CnAddressSelect.filterBeforeHandler = (props) => {
    const newProps = {
        ...props,
    };
    const { showTopLevel } = newProps || {};
    if (!newProps.config) {
        newProps.config = {
            apiModel: 'mtop',
            businessId: 'toffee',
        };
    }
    if (showTopLevel === true) {
        // newProps.maxLevel = 5
        newProps.iso = '';
    }
    else if (Array.isArray(showTopLevel) && showTopLevel.length > 0) {
        newProps.iso = '';
        newProps.includeList = showTopLevel;
    }
    delete newProps.showTopLevel;
    const lang = $i18n.getLang();
    if (lang) {
        const tempLocale = locale?.[lang];
        if (tempLocale) {
            newProps.locale = tempLocale;
        }
        newProps.dataLanguage = lang;
    }
    return newProps;
};
CnAddressSelect.formBeforeHandler = CnAddressSelect.filterBeforeHandler;
CnAddressSelect.defautlProps = {
    prefix: 'cn-next-',
};
